export default __webpack_public_path__ + "static/media/WelcomeB.95a477f8.jpg";